// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__TT7r-","title":"Menu_title__LYJQk","item":"Menu_item__jibtv","items":"Menu_items__YdaUE","active":"Menu_active__y1Jg4"};